.wrap {
  position: absolute;
  inset: 12% 10%;
  z-index: 10;
  background: rgba(14, 16, 20, 0.94);
  backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 16px;
  padding: 22px 26px;
  overflow: auto;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
}

.close {
  position: absolute;
  right: 10px;
  top: 8px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

.close:hover {
  background: rgba(255, 255, 255, 0.08);
}

.wrap h3 {
  margin: 0 0 12px;
  letter-spacing: -0.02em;
}

.wrap ul {
  margin: 0;
  padding-left: 18px;
  line-height: 1.7;
  font-size: 14px;
}

.wrap kbd {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 6px;
  padding: 1px 6px;
  font-size: 12px;
}
